'use client'

import React from 'react'
import { DlpButton } from '@ccpgames/eve-web-core'
import type { Button as ButtonFieldsFragment } from '@/graphql/types'
import styles from './Button.module.css'
import { useDlpTheme } from '@/components/providers/DlpThemeProvider'
import { toLibraryDlpTheme, type CmsDlpTheme } from '@/lib/dlp-theme'
import { PageReference, segmentsFromPageNextLeaf } from '@/helpers/page-href'
import i18nConfig from '@/i18n/i18nConfig'
import { useCurrentLocale } from 'next-i18n-router/client'
import { pagePathFromSegments } from '@/helpers/page-tree'

export interface ButtonProps {
  cta: ButtonFieldsFragment
  theme?: CmsDlpTheme
}

export function Button({ cta, theme }: ButtonProps) {
  const pageTheme = useDlpTheme()
  const resolvedTheme = theme ?? pageTheme
  const libraryTheme = toLibraryDlpTheme(resolvedTheme)
  let href = cta.url?.trim()
  const locale = useCurrentLocale(i18nConfig)
  const variant = cta.type === 'secondary' ? 'secondary' : 'primary'
  const content = cta.text

  const segments = segmentsFromPageNextLeaf(cta.page as PageReference)
  const pageUrl = pagePathFromSegments(locale || 'en', segments || [])

  if (segments?.length) {
    href = pageUrl
  }

  if (!href) {
    return null
  }

  return (
    <DlpButton
      className={styles.root}
      href={href}
      variant={variant}
      theme={libraryTheme}
      mt="md"
      mr="md"
      leftIcon={cta.icon?.url}
    >
      {content}
    </DlpButton>
  )
}
